import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore, useShopStore, useSettingsStore } from '../../store';
import { ROUTES } from '../../utils';
import AccessDenied from '../AccessDenied/AccessDenied';

function AdminRoute({ children }) {
  const { isAuthenticated, user } = useAuthStore();
  const { selectedShop } = useShopStore();
  const { settings } = useSettingsStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (!['admin', 'superadmin'].includes(user?.role)) {
    return <Navigate to="/workorders" replace />;
  }

  if (user?.role === 'superadmin' && !selectedShop) {
    return <Navigate to={ROUTES.SELECT_SHOP} replace />;
  }

  // Block access to hidden menu items for this shop
  const hiddenItems = settings?.hiddenMenuItems || [];
  const currentPath = '/' + location.pathname.split('/')[1];
  if (hiddenItems.includes(currentPath)) {
    return <AccessDenied />;
  }

  return children;
}

export default AdminRoute;
